import React, { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import "antd/dist/reset.css";
import "leaflet/dist/leaflet.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./Components/Dashboard";
import ServiceRequestList from "./Pages/ServiceRequestList";
import AppointmentBookingList from "./Pages/AppointmentBookingList";
import LoginPage from "./Components/LoginPage";
import InstallationList from "./Pages/InstallationList";
import AddProduct from "./Pages/AddProducts";
import ProductList from "./Pages/ProductList";
import AdvertisementForm from "./Pages/AddAdvertisement";
import LoadingSpinner from "./Components/LoadingSpinner";
import TechnicionList from "./Pages/TechnicianList";
import CustomerList from "./Pages/CustomerList";
import AssignTable from "./Pages/AssignTable";
import HomePage from "./Components/Home";
import InstallationDetails from "./Pages/InstallationDetailPage";
import OfferList from "./Pages/OfferList";
import AddOffersModal from "./Pages/AddOffers";
import AdvertisementList from "./Pages/AdvertisementList";
import ExtraAdvertisementList from "./Pages/ExtraAdvertisementList";
import ExtraAdvertisementModal from "./Pages/AddExtraAdvertisement";
import ServicesModal from "./Pages/AddServiceModel";
import ServicesList from "./Pages/ServiceList";
import CameraBrandsModal from "./Pages/AddCameraBrandsModal";
import CameraBrandsList from "./Pages/CameraBrandList";
import AddIntercommModal from "./Pages/AddIntercommModal";
import IntercommList from "./Pages/IntercommList";
import CameraTypeModal from "./Pages/AddCameraTypeModal";
import CameraTypeList from "./Pages/CameraTypeList";
import AddWiredMasterModal from "./Pages/AddWiredModal";
import WiredMasterList from "./Pages/WiredList";
import RequestModal from "./Pages/AddRequestModal";
import RequestList from "./Pages/RequestList";
import SitetypeModal from "./Pages/AddSiteTypeModal";
import SitetypeList from "./Pages/SiteTypeList";
import TimeslotModal from "./Pages/AddTimeSlotModal";
import TimeslotList from "./Pages/TimeSlotList";
import RequesttypeModal from "./Pages/AddSurveyAimModal";
import RequesttypeList from "./Pages/SurveyAimList";
import OffertypeModal from "./Pages/AddOfferTypeModal";
import OffertypeList from "./Pages/OfferTypeList";
import StatusModal from "./Pages/AddStatusModal";
import StatusList from "./Pages/StatusList";
import RouteTrackingWithArrows from "./Pages/livemap";
import InstallationReport from "./Pages/Report";
import PrivateRoute from "./Components/PrivateRoute";
import CustomerDetails from "./Pages/CustomerDetails";
import PackageList from "./Pages/PackageList";
import AddPackageModal from "./Pages/AddPackageModal";
import AddPackagePurchaseModal from "./Pages/AddPackagePurchasedCustomers";
import PackagePurchaseList from "./Pages/PackagePurchasedCustomersList";
import AddPackageTypeModal from "./Pages/AddPackageTypeModal";
import PackageTypeList from "./Pages/PackagetypeList";
import AddPackageSubTypeModal from "./Pages/AddPackageSubtype";
import PackageSubTypeList from "./Pages/PackageSubtypeList";
import TechnicianDetails from "./Pages/TechnicianDetail";
import AddStories from "./Pages/AddStories";
import StoriesList from "./Pages/StoriesList";
import CustomerReviewsList from "./Pages/CustomerVideoReviewsList";
import AddCustomerVideoreviews from "./Pages/AddCustomerReviews";
import Ai from "./Pages/Ai";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />

          <Route element={<PrivateRoute />}>
            <Route path="/dashboard" element={<Dashboard />}>
              <Route index element={<HomePage />} />

              <Route path="home" element={<HomePage />} />
              <Route
                path="service-request-list"
                element={<ServiceRequestList />}
              />
              <Route
                path="appointment-booking-list"
                element={<AppointmentBookingList />}
              />
              <Route path="installation-list" element={<InstallationList />} />
              <Route path="add-product" element={<AddProduct />} />
              <Route path="product-list" element={<ProductList />} />
              <Route path="add-advertisement" element={<AdvertisementForm />} />
              <Route path="technician-list" element={<TechnicionList />} />
              <Route path="technicians/:id" element={<TechnicianDetails />} />
              <Route path="customer-list" element={<CustomerList />} />
              <Route path="customers/:id" element={<CustomerDetails />} />
              <Route path="assigntable" element={<AssignTable />} />
              <Route
                path="installation-detailpage/:id"
                element={<InstallationDetails />}
              />
              <Route path="offer-list" element={<OfferList />} />
              <Route path="add-offer" element={<AddOffersModal />} />
              <Route
                path="advertisement-list"
                element={<AdvertisementList />}
              />
              <Route
                path="extraadvertisement-list"
                element={<ExtraAdvertisementList />}
              />
              <Route
                path="add-extraadvertisement"
                element={<ExtraAdvertisementModal />}
              />
              <Route path="add-service" element={<ServicesModal />} />
              <Route path="service-list" element={<ServicesList />} />
              <Route path="add-camerabrand" element={<CameraBrandsModal />} />
              <Route path="camerabrand-list" element={<CameraBrandsList />} />
              <Route path="add-intercomm" element={<AddIntercommModal />} />
              <Route path="intercomm-list" element={<IntercommList />} />
              <Route path="add-cameratype" element={<CameraTypeModal />} />
              <Route path="cameratype-list" element={<CameraTypeList />} />
              <Route path="add-wiredmaster" element={<AddWiredMasterModal />} />
              <Route path="wiredmaster-list" element={<WiredMasterList />} />
              <Route path="add-request" element={<RequestModal />} />
              <Route path="request-list" element={<RequestList />} />
              <Route path="add-sitetype" element={<SitetypeModal />} />
              <Route path="sitetype-list" element={<SitetypeList />} />
              <Route path="add-timeslot" element={<TimeslotModal />} />
              <Route path="timeslot-list" element={<TimeslotList />} />
              <Route path="add-requesttype" element={<RequesttypeModal />} />
              <Route path="requesttype-list" element={<RequesttypeList />} />
              <Route path="add-offertype" element={<OffertypeModal />} />
              <Route path="offertype-list" element={<OffertypeList />} />
              <Route
                path="add-packagepurchase"
                element={<AddPackagePurchaseModal />}
              />
              <Route path="packagepurchses" element={<PackagePurchaseList />} />
              <Route path="add-status" element={<StatusModal />} />
              <Route path="status-list" element={<StatusList />} />
              <Route path="livemap/:id" element={<RouteTrackingWithArrows />} />
              <Route
                path="installation-map/:id"
                element={<RouteTrackingWithArrows />}
              />
              <Route path="report" element={<InstallationReport />} />
              <Route path="packages" element={<PackageList />} />
              <Route path="add-package" element={<AddPackageModal />} />
              <Route path="packagetype" element={<AddPackageTypeModal />} />
              <Route path="packagetype-list" element={<PackageTypeList />} />
              <Route
                path="packagesubtype"
                element={<AddPackageSubTypeModal />}
              />
              <Route
                path="packagesubtype-list"
                element={<PackageSubTypeList />}
              />
              <Route path="add-stories" element={<AddStories />} />
              <Route path="stories-list" element={<StoriesList />} />
              <Route
                path="add-customervideoreviews"
                element={<AddCustomerVideoreviews />}
              />
              <Route
                path="customerVideoReviews-list"
                element={<CustomerReviewsList />}
              />
              <Route path="Ai-chat" element={<Ai />} />
            </Route>
          </Route>

          <Route path="*" element={<LoginPage />} />
        </Routes>
      </Router>

      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          style: {
            background: "#1e1e2f",
            color: "#fff",
            borderRadius: "10px",
            padding: "12px 16px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
            fontSize: "14px",
          },
          success: {
            style: { background: "#22c55e", color: "#fff" },
            iconTheme: { primary: "#fff", secondary: "#16a34a" },
          },
          error: {
            style: { background: "#ef4444", color: "#fff" },
            iconTheme: { primary: "#fff", secondary: "#dc2626" },
          },
          loading: {
            style: { background: "#2563eb", color: "#fff" },
          },
        }}
      />
    </>
  );
}

export default App;
